var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.7342,
    r: 32.5,
    fill: "#0156FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1264_7772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.82 44.8824L33 47.7024L30.18 44.8824C24.6375 43.6024 20.5 38.6324 20.5 32.7024C20.5 25.8024 26.1 20.2024 33 20.2024C39.9 20.2024 45.5 25.8024 45.5 32.7024C45.5 38.6324 41.3625 43.6024 35.82 44.8824ZM25.5287 36.9724C27.3637 39.7099 30.1187 41.4524 33.2 41.4524C36.28 41.4524 39.0362 39.7112 40.87 36.9724C38.7897 35.0282 36.0474 33.9484 33.2 33.9524C30.3521 33.9481 27.6094 35.0279 25.5287 36.9724ZM33 31.4524C33.9946 31.4524 34.9484 31.0574 35.6517 30.3541C36.3549 29.6508 36.75 28.697 36.75 27.7024C36.75 26.7079 36.3549 25.754 35.6517 25.0508C34.9484 24.3475 33.9946 23.9524 33 23.9524C32.0054 23.9524 31.0516 24.3475 30.3483 25.0508C29.6451 25.754 29.25 26.7079 29.25 27.7024C29.25 28.697 29.6451 29.6508 30.3483 30.3541C31.0516 31.0574 32.0054 31.4524 33 31.4524Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1264_7772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(18 17.7024)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.722ae8badc722cf1513749cd8f9aaef2.svg";
export { ForwardRef as ReactComponent };